import React, {Component} from 'react';
import actions from '../actions';
import {COMMENTS__24, COMMENTS_16} from '../../../components/svg-def';
import {compose} from 'redux';
import {connect} from 'react-redux';
import edap from '../edap';
import {graphql} from 'react-apollo';
import {SVGIcon} from '@homeaway/react-svg';
import {withAuth} from '../../../components/auth';
import {withTranslationsAsProps} from '../../../components/translations';
import classnames from 'classnames';
import {
    GET_NOTES,
    getOptions,
    mapStateToProps
} from './comments-graphql';
import './comments-icon.less';


export class CommentsIcon extends Component {
    constructor(props) {
        super(props);
        this.buttonRef = React.createRef();
        this.onClick = this.onClick.bind(this);
    }

    componentDidMount() {
        // onClick via React does not work when rendered inside a google overlay
        // istanbul ignore next
        if (this.buttonRef.current) {
            this.buttonRef.current.addEventListener('click', this.onClick);
        }
    }

    componentWillUnmount() {
        // istanbul ignore next
        if (this.buttonRef.current) {
            this.buttonRef.current.removeEventListener('click', this.onClick);
        }
    }

    onClick(event) {
        const {
            baseLocation,
            boardId,
            endDate,
            listingId,
            open,
            startDate,
            ...rest
        } = this.props;
        edap.viewComments(boardId, endDate, listingId, startDate);
        open({baseLocation, endDate, boardId, listingId, startDate, ...rest});
        event.preventDefault();
    }

    render() {
        const {
            className,
            data: {localizedUnitNotes: unitNotes},
            langAddComment,
            isSmall = false
        } = this.props;
        const count = unitNotes && unitNotes.pagination && unitNotes.pagination.totalItems || 0;

        return (
            <div className={`comments-icon ${className || ''}`}>
                <button
                    aria-label={langAddComment}
                    className={classnames('comments-icon__button', {'comments-icon__button--small': isSmall})}
                    type="button"
                    ref={this.buttonRef}
                >
                    <SVGIcon className="comments-icon__SVGIcon" markup={isSmall ? COMMENTS_16 : COMMENTS__24} />
                </button>
                {count > 0 &&
                    <span className="comments-icon__count text-muted text-sm">{count}</span>
                }
            </div>
        );
    }
}

CommentsIcon.defaultProps = {
    data: {},
    open: () => {}
};

export const mapDispatchToProps = {
    open: actions.open
};

export default compose(
    withAuth,
    connect(mapStateToProps, mapDispatchToProps),
    graphql(GET_NOTES, {options: getOptions}),
    withTranslationsAsProps({
        'tripboards.add.comment': 'langAddComment'
    })
)(CommentsIcon);



// WEBPACK FOOTER //
// ./src/universal/tripboard/comments/components/comments-icon.js